export default {
    clientBanner: {
        title: '客户端 Banner 配置',
        subtitle: '配置项 key: {key} · module: {module}',
        readOnly: '当前账号仅有查看权限，如需编辑请在角色管理中授予「服务配置-编辑」权限。',
        previewJson: '预览 JSON',
        load: {
            failed: '加载 Banner 配置失败',
        },
        save: {
            success: 'Banner 配置已保存',
            failed: '保存 Banner 配置失败',
            conflict: '配置已被他人更新，已重新加载最新数据，请确认后再次保存',
            removedDeleted: '已自动移除 {count} 个不可用短剧（已删除/已下架/列表不可见）并保存配置',
        },
        upload: {
            success: '上传成功',
            failed: '上传失败',
        },
        settings: {
            enabled: '总开关',
            enabledRequiresItems: '请先选择剧集后再开启 Banner',
        },
        picker: {
            panelTitle: '剧集库',
            search: '搜索剧名或 ID',
            onlineOnly: '仅显示已上线',
            loaded: '共 {total} 部',
            total: '共 {total} 部',
            maxReached: '最多选择 {max} 个 Banner',
            unavailable: '已删除或已下架的短剧不能加入 Banner',
            select: '选择',
            cover: '封面',
            title: '剧名',
            status: '状态',
        },
        list: {
            title: '已选 Banner',
            count: '共 {count}/{max} 项',
            empty: '请从左侧剧集库勾选剧集',
            missing: '剧集不存在',
            bannerPreview: 'Banner 预览',
            thumbPreview: '缩略图预览',
            uploadBanner: '上传 Banner 图',
            uploadThumb: '上传缩略图',
            uploadPreview: '上传预览视频',
            titleLabel: 'Banner 标题',
            descriptionLabel: 'Banner 描述',
            effectiveDescriptionLabel: '客户端生效描述',
            titleOverride: '可修改标题，留空则使用剧集默认',
            descriptionOverride: '可修改描述，留空则使用剧集默认',
            restoreDefault: '恢复默认',
            defaultTitle: '剧集默认标题：{title}',
            defaultDescription: '剧集默认描述：{description}',
            dramaMetaLabel: '剧集统计信息',
            dramaMetaEmpty: '暂无统计数据（保存后会从剧集列表或上次配置合并）',
            dramaMeta:
                '集数 {episodes} · 创作者 {creator} · 播放 {plays} · 热度 {heat} · 评分 {rating}',
            dramaMetaHint: '以上字段保存时从剧集列表自动合并，无需手填',
        },
    },
};
